export default __webpack_public_path__ + "static/media/omaramen400.d443e338.png";